import { action } from 'typesafe-actions'
import { LoadingActionTypes } from './types'

export const startLoading = () => action(LoadingActionTypes.START_LOADING)

export const finishLoading = () => action(LoadingActionTypes.FINISH_LOADING)
